// src/lib/frameworkDescriptions/nistCsfDomains.ts
// Reusable NIST CSF 2.0 function descriptions for hover tooltips across all questionnaires.

export interface NistCsfDomainInfo {
  code: string;
  title: string;
  description: string;
}

export const NIST_CSF_DOMAIN_DESCRIPTIONS: Record<string, NistCsfDomainInfo> = {
  GV: {
    code: "GV",
    title: "Govern",
    description:
      "Establishes organizational cybersecurity governance, strategy, risk management policies, and oversight structures to ensure cybersecurity aligns with enterprise objectives and regulatory obligations.",
  },
  ID: {
    code: "ID",
    title: "Identify",
    description:
      "Develops an understanding of organizational systems, assets, data, and cybersecurity risks to support effective risk management and prioritization of security activities.",
  },
  PR: {
    code: "PR",
    title: "Protect",
    description:
      "Implements safeguards and controls designed to secure critical services, systems, and data, limiting the impact of potential cybersecurity events.",
  },
  DE: {
    code: "DE",
    title: "Detect",
    description:
      "Enables timely discovery of cybersecurity events through monitoring, anomaly detection, and security operations capabilities.",
  },
  RS: {
    code: "RS",
    title: "Respond",
    description:
      "Defines and executes appropriate actions to contain, analyze, and mitigate cybersecurity incidents once they are detected.",
  },
  RC: {
    code: "RC",
    title: "Recover",
    description:
      "Supports restoration of capabilities or services impaired by cybersecurity incidents and ensures lessons learned improve future resilience.",
  },
};
